import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router";
import { CONSTANTS } from "../constants";
import { headers } from "../network";

const useLogout = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const logout = () => {
    queryClient.clear();
    headers.authorization = undefined;
    navigate(CONSTANTS.ROUTES.login, { replace: true });
  };

  return logout;
};

export default useLogout;
